import { isValidPhoneNumber, parsePhoneNumber, formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'
import { allowedPhoneCountries } from '../env'

// Countries the API accepts phone numbers from (mirrors the API's allowedPhoneCountries).
// The API is the real enforcement; this only keeps the picker to valid choices.
export const ALLOWED_PHONE_COUNTRIES = String(allowedPhoneCountries || 'US')
  .split(',')
  .map((c) => c.trim().toUpperCase())
  .filter(Boolean)

const safeParse = (value) => {
  try {
    return parsePhoneNumber(String(value), 'US')
  } catch (e) {
    return undefined
  }
}

export const isAllowedPhoneNumber = (value) => {
  if (!value || !isValidPhoneNumber(value)) return false
  return ALLOWED_PHONE_COUNTRIES.includes(safeParse(value)?.country)
}

// Value for the phone input. "+..." values (stored E.164, or partial input while typing)
// pass through; legacy records holding e.g. "(435) 840-2430" are converted best-effort.
export const toE164 = (value) => {
  if (!value) return undefined
  const str = String(value).trim()
  if (str.startsWith('+')) return str
  return safeParse(str)?.number
}

// Display a stored phone: US numbers as (xxx) xxx-xxxx, others in international format.
// Unparseable legacy values are shown as-is.
export const formatPhoneDisplay = (value) => {
  if (!value) return ''
  const parsed = safeParse(value)
  if (!parsed) return String(value)
  return parsed.country === 'US' ? formatPhoneNumber(parsed.number) : formatPhoneNumberIntl(parsed.number)
}
